import React from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';
import Wrapper from '../common/Wrapper';
import DivFooter from '../common/DivFooter';
import NewsList from '../news/NewsList';
import Empty from '../common/Empty';

const NewsPage = () => {
    return (
    <Wrapper>
         <DivFooter>
            <Header/>
            <Empty/>
            <NewsList/>
            <Empty/>
            
        <Footer/>
            </DivFooter>

    
    </Wrapper>
    );
};

export default NewsPage;